import { styled } from 'parkdepot-shared/theme'

export const LotTitle = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingMedium,
    fontWeight: 700,
    marginTop: 0,
    marginBottom: '1.2rem'
}))

export const StickySection = styled('div', ({ $theme }) => ({
    display: 'flex',
    border: '1px solid #CCCCCC',
    borderBottom: 'none',
    padding: '2.4rem 1.6rem',
    justifyContent: 'space-between',
    backgroundColor: '#fff',

    [$theme.mediaQuery.large]: {
        border: 'none'
    }
}))

export const Line = styled('div', ({ $theme }) => ({
    height: '1px',
    width: '100%',
    backgroundColor: '#F7F7FF',
    margin: '1.2rem 0'
}))

export const Container = styled('div', ({ $theme }) => ({
    padding: '0 1.5rem 3.2rem',
    marginTop: '2rem'
}))

export const LoadingAnimationWrapper = styled('div', ({ $theme }) => ({
    height: '22rem',
    display: 'flex'
}))
